import { useEffect, useState } from 'react'

const useFetchByID = (
  fetchFunction,
  fetchByID,
  cache = null, // TODO: change it and cacheKey
  cacheKey = null
) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [data, setData] = useState({})

  useEffect(() => {
    let result = cache?.getCache(cacheKey)
    if (result) {
      setData(result)
      setIsLoaded(true)
    } else {
      ;(async () => {
        result = await fetchFunction(fetchByID)
        setData(result)
        setIsLoaded(true)
        cache?.cache(cacheKey, result)
      })()
    }
  }, [fetchFunction, fetchByID, cache, cacheKey])

  return {
    data,
    isLoaded
  }
}

export default useFetchByID
